export const compleannoSegretario2025 = {
  id: 'static-compleanno-segretario-2025',
  slug: 'compleanno-segretario-2025',
  title: 'Buon compleanno al nostro Segretario Nazionale Giuseppe Guarino!',
  excerpt: 'Oggi è un giorno speciale per tutta la famiglia UNASCA: il nostro Segretario Nazionale Giuseppe Guarino compie gli anni. Un augurio affettuoso che va ben oltre la semplice ricorrenza.',
  body: `
    <div style="background: linear-gradient(135deg, #00bf8f 0%, #20c997 100%); color: white; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 191, 143, 0.3);">
      <h2 style="font-size: 2rem; margin-bottom: 1rem; font-weight: 600; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);">
        <i class="fas fa-birthday-cake"></i> Buon compleanno Giuseppe!
      </h2>
      <p style="font-size: 1.2rem; line-height: 1.6; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);">
        Oggi è il compleanno del nostro Segretario Nazionale <strong>Giuseppe Guarino</strong> e vogliamo cogliere l'occasione per fargli i nostri auguri più sinceri.
      </p>
    </div>

    <p>Un pensiero semplice, ma sentito, da parte di tutta UNASCA – perché chi lavora ogni giorno con dedizione merita un grazie. Il suo impegno è costante, concreto, e si riflette nel buon funzionamento dell'associazione.</p>

    <p>Con lui al timone, il lavoro della Segreteria procede con equilibrio e attenzione, e questo non può che fare bene a tutti noi.</p>

    <blockquote style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.1) 0%, rgba(0, 191, 143, 0.05) 100%); border-left: 4px solid #00bf8f; padding: 1.5rem; margin: 2rem 0; border-radius: 0 12px 12px 0; font-style: italic; font-size: 1.1rem; color: #2c3e50;">
      Buon compleanno Giuseppe, e buon lavoro.
    </blockquote>

    <div style="text-align: center; margin: 2rem 0;">
      <img src="/images/auguri_segretario.jpg" alt="Buon compleanno Giuseppe Guarino - Segretario Nazionale UNASCA" style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <p style="margin-top: 1rem; font-size: 0.9rem; color: #6c757d; text-align: center; font-style: italic;">
        <i class="fas fa-birthday-cake"></i> Buon compleanno Giuseppe - Da tutta la famiglia UNASCA
      </p>
    </div>
  `,
  featuredImage: '/images/auguri_segretario.jpg',
  category: {
    id: 'generale',
    name: 'Generale',
    slug: 'generale',
    color: '#6B7280'
  },
  tags: ['Giuseppe Guarino', 'Compleanno', 'Segretario Nazionale', 'Auguri'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-07-08T10:00:00Z',
  createdAt: '2025-07-08T10:00:00Z',
  updatedAt: '2025-07-08T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 1
};

